module.exports = __webpack_public_path__ + "static/media/3.e56c177c.png";